import { Box, Card, CardContent, Grid, Link, Typography } from "@mui/material";
import React from "react";
import { Reveal } from "src/theme/animation";

interface Advisor {
    name: string;
    title: string;
    link: string;
    photo?: string;
}

const ADVISORS: Advisor[] = [
    { name: "Sean Valentine", title: "CEO", link: "https://www.linkedin.com/in/sean-valentine-b370349b/", photo: "/team/sean-valentine.jpeg" },
    { name: "Kyjeila Latimer, PhD", title: "Lead Data Analysis and Compliance Consultant", link: "https://www.linkedin.com/in/kyjeila-latimer-ph-d-3879b6187/", photo: "/team/kyjelia-latimer.jpeg" },
    { name: "Eli Taylor", title: "Lead Technical Consultant", link: "https://www.linkedin.com/in/elitaylor/", photo: "/team/eli-taylor.jpeg" },
    { name: "Cathy Barragan", title: "Lead Brand Marketing and Internal Operations Consultant", link: "https://www.linkedin.com/in/cathybarragan/", photo: "/team/cathy-barragan.jpeg" },
    { name: "Janine Oneill", title: "Early Stage Talent Development Advisor, Executive Coach", link: "https://www.linkedin.com/in/janine-o-neill-she-her-81629/", photo: "/team/janine-oneill.jpeg" },
    { name: "Teddy Shalon", title: "Lead Business Development Advisor", link: "https://www.linkedin.com/in/teddyshalon/", photo: "/team/teddy-shalon.jpeg" },
    { name: "Ted Paff", title: "Lead Business Finance Advisor", link: "https://www.linkedin.com/in/ted-paff-5323602/", photo: "/team/ted-paff.jpeg" },
    { name: "Trevin York", title: "Lead Product Development Advisor", link: "https://www.linkedin.com/in/trevin-york/", photo: "/team/trevin-york.jpeg" },
    { name: "Jonathan Wheat", title: "Lead Risk Advisor", link: "https://www.linkedin.com/in/jonathan-wheat-cpcu-cris-abb24a49/", photo: "/team/jonathan-wheat.jpeg" },
    { name: "Dr. Kim Moses", title: "Lead Education Operations Advisor", link: "https://www.linkedin.com/in/kim-moses-6b513550/", photo: "/team/kim-moses.jpeg" },
    { name: "Scott Hanselman", title: "Lead Tech Development Advisor", link: "https://www.linkedin.com/in/shanselman/", photo: "/team/scott-hanselman.jpeg" },
    { name: "Brandy Spong", title: "Education Policy Advisor", link: "https://www.linkedin.com/in/brandy-spong/", photo: "/team/brandy-spong.jpeg" },
    { name: "Aren Ulmer, MA, CMPC, MHFA", title: "Lead Sports Mental Performance Advisor", link: "https://www.linkedin.com/in/aren-ulmer/", photo: "/team/aren-ulmer.jpeg" },
    { name: "Matthew Dedon", title: "Lead Legal & Compliance Consultant", link: "https://www.linkedin.com/in/matthew-dedon/", photo: "/team/matthew-dedon.jpeg" }
];

const Advisors: React.FC = () => {
    return (
        <Box sx={{ mb: 8 }}>
            <Reveal variant="fadeUp">
                <Typography
                    variant="h3"
                    component="h2"
                    sx={{
                        textAlign: "center",
                        mb: 6,
                        fontWeight: "bold"
                    }}
                >
                    Team &amp; Advisors
                </Typography>
            </Reveal>

            <Grid container spacing={3}>
                {ADVISORS.map((advisor, idx) => (
                    <Grid item xs={12} sm={6} md={3} key={idx}>
                        <Reveal variant="fadeUp" delay={idx * 0.06}>
                            <Card
                            component={Link}
                            href={advisor.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            elevation={2}
                            sx={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                transition: "transform 0.2s ease-in-out",
                                textDecoration: "none",
                                color: "inherit",
                                "&:hover": {
                                    transform: "translateY(-2px)",
                                    boxShadow: 4,
                                    textDecoration: "none"
                                }
                            }}
                        >
                            <CardContent sx={{ flexGrow: 1, textAlign: advisor.photo ? "center" : "left" }}>
                                {advisor.photo && (
                                    <Box
                                        component="img"
                                        src={advisor.photo}
                                        alt={advisor.name}
                                        sx={{
                                            width: 120,
                                            height: 120,
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            mb: 2,
                                            boxShadow: "0 2px 10px rgba(0,0,0,0.15)"
                                        }}
                                    />
                                )}
                                <Typography
                                    variant="h6"
                                    component="h3"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "primary.main",
                                        mb: 0.5
                                    }}
                                >
                                    {advisor.name}
                                </Typography>
                                <Typography variant="body2" sx={{ color: "text.secondary", lineHeight: 1.5 }}>
                                    {advisor.title}
                                </Typography>
                            </CardContent>
                                </Card>
                        </Reveal>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Advisors;
